import React from "react";
import { Divider } from "antd";
import {
  Content,
  Head,
  ConnectName,
  DeviceName,
  NumberDevice,
  Text,
  Title,
} from "../../ModalStyled.styled";
import { WarningIcon } from "./../../../../_assests";

export default function ConfirmWarning({ connectName, data }) {
  const checkNumberDevice = data?.filter((item, idx) => {
    return item.summToPaid;
  });

  return (
    <Content>
      <Head>
        <WarningIcon />
        <Title>Подтвердите ввод показаний</Title>
      </Head>
      <Divider />
      {checkNumberDevice?.map((item) => {
        return (
          <>
            <ConnectName>{connectName}</ConnectName>
            <DeviceName>Заводской номер прибора учета</DeviceName>
            <NumberDevice>{item.meteringDeviceNumber}</NumberDevice>
            <Text>{item.summToPaid}</Text>
          </>
        );
      })}
    </Content>
  );
}
